// import React from 'react';
// import './App.css';
// import { BrowserRouter, Routes } from "react-router-dom";
// import routes from './Routes/index.js';
// import { getRoutes } from './lib/getRoutes.js';

// import QueryProvider from './core/provider/ReactQuery/index.js';
// import ToastProvider from './core/provider/ToastProvider/index.js';
// import { AuthProvider } from './core/provider/Auth/index.js';
// import ProtectedRoute from './core/provider/ProtectedRoute/index.js';
// import { HeaderActionsProvider } from './core/provider/HeaderActionProvider/HeaderAction.js';
// import { Provider } from 'react-redux';
// import { persistor, store } from './core/store/index.js';
// import { PersistGate } from 'redux-persist/integration/react';

// function App() {
//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <QueryProvider>
//           <AuthProvider>
//             <HeaderActionsProvider>
//               <BrowserRouter basename="/app">
//                 <ToastProvider />
//                 <ProtectedRoute>
//                   <Routes>
//                     {getRoutes(routes)}
//                   </Routes>
//                 </ProtectedRoute>
//               </BrowserRouter>
//             </HeaderActionsProvider>
//           </AuthProvider>
//         </QueryProvider>
//       </PersistGate>
//     </Provider>
//   );
// }

// export default App;
// // App.tsx
// import { Suspense, useEffect, useState } from "react";
// import "./App.css";
// import { BrowserRouter, Routes } from "react-router-dom";
// import routes from "./Routes/index.js";
// import { getRoutes } from "./lib/getRoutes.js";

// import QueryProvider from "./core/provider/ReactQuery/index.js";
// import ToastProvider from "./core/provider/ToastProvider/index.js";
// import { AuthProvider } from "./core/provider/Auth/index.js";
// import ProtectedRoute from "./core/provider/ProtectedRoute/index.js";
// import { HeaderActionsProvider } from "./core/provider/HeaderActionProvider/HeaderAction.js";
// import { Provider } from "react-redux";
// import { persistor, store } from "./core/store/index.js";
// import { PersistGate } from "redux-persist/integration/react";
// import { GlobalLoader } from "./components/ui/GlobalLoader/index.js";
// import PWAInstallPrompt from "./components/ui/PWAReloadPrompt/PWAInstallPrompt.js";
// import GlobalShortcuts from "./components/ui/GlobalShortcuts/index.js";
// import SplashScreen from "./components/ui/SplashScreen/index.js";
// import { toastify } from "./components/ui/Toasts/index.js";

// type ToastFn = (type: "success" | "error" | "warning" | "info", message: string) => void;

// let toastFn: ToastFn | null = null;

// export const setToastFn = (fn: ToastFn) => {
//   toastFn = fn;
// };

// export const showToast = (type: "success" | "error" | "warning" | "info", message: string) => {
//   if (!toastFn) return;
//   toastFn(type, message);
// };

// const SPLASH_DURATION = 2200;
// const SPLASH_EXIT_DURATION = 700;

// /**
//  * تشخیص PWA موبایل:
//  * - در حالت standalone اجرا شود (نصب‌شده)
//  * - دستگاه موبایل باشد
//  */
// const isMobilePWA = () => {
//   if (typeof window === "undefined") return false;

//   const isStandalone =
//     window.matchMedia("(display-mode: standalone)").matches ||
//     (window.navigator as any).standalone === true; // iOS Safari

//   const isMobile =
//     /Android|iPhone|iPad|iPod|Mobile/i.test(window.navigator.userAgent);

//   return isStandalone && isMobile;
// };

// function App() {
//   // اگر PWA موبایل نبود، از همان اول Splash را غیرفعال کن
//   const [showSplash, setShowSplash] = useState<boolean>(() => isMobilePWA());
//   const [isReady, setIsReady] = useState<boolean>(() => !isMobilePWA());

//   useEffect(() => {
//     setToastFn(toastify);
//   }, []);

//   useEffect(() => {
//     // فقط اگر PWA موبایل هستیم منتظر Splash بمان
//     if (!isMobilePWA()) {
//       return;
//     }

//     const timer = setTimeout(() => {
//       setIsReady(true);
//     }, SPLASH_DURATION + SPLASH_EXIT_DURATION);

//     return () => clearTimeout(timer);
//   }, []);
  

//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <QueryProvider>
//           <AuthProvider>
//             <BrowserRouter basename="/app">
//               <HeaderActionsProvider>
//                 <ToastProvider />
//                 <GlobalLoader />
//                 <GlobalShortcuts />

//                 {/* فقط در PWA موبایل */}
//                 {showSplash && (
//                   <SplashScreen
//                     onFinish={() => setShowSplash(false)}
//                     minDisplayTime={SPLASH_DURATION}
//                   />
//                 )}

//                 {isReady && (
//                   <ProtectedRoute>
//                     {/* <PWAInstallPrompt /> */}
//                     <Suspense fallback={<GlobalLoader />}>
//                       <Routes>{getRoutes(routes)}</Routes>
//                     </Suspense>
//                   </ProtectedRoute>
//                 )}
//               </HeaderActionsProvider>
//             </BrowserRouter>
//           </AuthProvider>
//         </QueryProvider>
//       </PersistGate>
//     </Provider>
//   );
// }

// export default App;

import { Suspense, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes } from "react-router-dom";
import routes from "./Routes/index.js";
import { getRoutes } from "./lib/getRoutes.js";

import QueryProvider from "./core/provider/ReactQuery/index.js";
import ToastProvider from "./core/provider/ToastProvider/index.js";
import { AuthProvider } from "./core/provider/Auth/index.js";
import ProtectedRoute from "./core/provider/ProtectedRoute/index.js";
import { HeaderActionsProvider } from "./core/provider/HeaderActionProvider/HeaderAction.js";
import { Provider } from "react-redux";
import { persistor, store } from "./core/store/index.js";
import { PersistGate } from "redux-persist/integration/react";
import { GlobalLoader } from "./components/ui/GlobalLoader/index.js";
import PWAInstallPrompt from "./components/ui/PWAReloadPrompt/PWAInstallPrompt.js";
import GlobalShortcuts from "./components/ui/GlobalShortcuts/index.js";
import SplashScreen from "./components/ui/SplashScreen/index.js";
import { toastify } from "./components/ui/Toasts/index.js";

type ToastFn = (type: "success" | "error" | "warning" | "info", message: string) => void;

let toastFn: ToastFn | null = null;

export const setToastFn = (fn: ToastFn) => {
    toastFn = fn;
};

export const showToast = (type: "success" | "error" | "warning" | "info", message: string) => {
    if (!toastFn) return;
    toastFn(type, message);
};

const SPLASH_DURATION = 2200;
const SPLASH_EXIT_DURATION = 700;

/**
 * تشخیص PWA موبایل
 */
const isMobilePWA = () => {
    if (typeof window === "undefined") return false;
    const isStandalone =
        window.matchMedia("(display-mode: standalone)").matches ||
        (window.navigator as any).standalone === true;
    const isMobile =
        /Android|iPhone|iPad|iPod|Mobile/i.test(window.navigator.userAgent);
    return isStandalone && isMobile;
};

// ============================================================
// 🔒 هوک ضد زوم — زوم مرورگر رو در دسکتاپ خنثی می‌کند
// ============================================================
function useAntiZoom() {
    useEffect(() => {
        // ۱. جلوگیری از Ctrl + Wheel (زوم با موس)
        const handleWheel = (e: WheelEvent) => {
            if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        };

        // ۲. جلوگیری از Ctrl + "+" / "-" / "0" (زوم با کیبورد)
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey || e.metaKey) {
                const key = e.key;
                if (
                    key === "+" || key === "-" || key === "=" || key === "_" || key === "0"
                ) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        };

        // ۳. جلوگیری از pinch zoom در دسکتاپ (ترک‌پد مک)
        const handleTouchMove = (e: TouchEvent) => {
            if (e.touches.length > 1) {
                e.preventDefault();
            }
        };

        // ۴. جلوگیری از دابل‌تپ زوم در iOS
        let lastTouchEnd = 0;
        const handleDoubleTap = (e: TouchEvent) => {
            const now = Date.now();
            if (now - lastTouchEnd <= 300) {
                e.preventDefault();
            }
            lastTouchEnd = now;
        };

        // ۵. قفل کردن zoom در همه‌ی حالت‌ها (fallback)
        const lockZoom = () => {
            document.body.style.zoom = "1";
            (document.body.style as any).MozTransform = "scale(1)";
            document.body.style.transform = "scale(1)";
        };

        document.addEventListener("wheel", handleWheel, { passive: false });
        document.addEventListener("keydown", handleKeyDown, { passive: false });
        document.addEventListener("touchmove", handleTouchMove, { passive: false });
        document.addEventListener("touchend", handleDoubleTap, { passive: false });
        window.addEventListener("resize", lockZoom);

        // اجرای اولیه
        lockZoom();

        return () => {
            document.removeEventListener("wheel", handleWheel);
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("touchmove", handleTouchMove);
            document.removeEventListener("touchend", handleDoubleTap);
            window.removeEventListener("resize", lockZoom);
        };
    }, []);
}

function App() {
    const [showSplash, setShowSplash] = useState<boolean>(() => isMobilePWA());
    const [isReady, setIsReady] = useState<boolean>(() => !isMobilePWA());

    // 🔒 فعال‌سازی ضد زوم
    useAntiZoom();

    useEffect(() => {
        setToastFn(toastify);
    }, []);

    useEffect(() => {
        if (!isMobilePWA()) return;
        const timer = setTimeout(() => {
            setIsReady(true);
        }, SPLASH_DURATION + SPLASH_EXIT_DURATION);
        return () => clearTimeout(timer);
    }, []);

    console.log({
      devicePixelRatio: window.devicePixelRatio,
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      screenWidth: screen.width,
      screenHeight: screen.height,
      zoom: window.outerWidth / window.innerWidth,
  });
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <QueryProvider>
                    <AuthProvider>
                        <BrowserRouter basename="/app">
                            <HeaderActionsProvider>
                                <ToastProvider />
                                <GlobalLoader />
                                <GlobalShortcuts />

                                {showSplash && (
                                    <SplashScreen
                                        onFinish={() => setShowSplash(false)}
                                        minDisplayTime={SPLASH_DURATION}
                                    />
                                )}

                                {isReady && (
                                    <ProtectedRoute>
                                        <Suspense fallback={<GlobalLoader />}>
                                            <Routes>{getRoutes(routes)}</Routes>
                                        </Suspense>
                                    </ProtectedRoute>
                                )}
                            </HeaderActionsProvider>
                        </BrowserRouter>
                    </AuthProvider>
                </QueryProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;

// with pwa
// import './App.css';
// import { BrowserRouter, Routes } from "react-router-dom";
// import { useState, useEffect } from 'react';
// import routes from './Routes/index.js';
// import { getRoutes } from './lib/getRoutes.js';
// import QueryProvider from './core/provider/ReactQuery/index.js';
// import ToastProvider from './core/provider/ToastProvider/index.js';
// import { AuthProvider } from './core/provider/Auth/index.js';
// import ProtectedRoute from './core/provider/ProtectedRoute/index.js';
// import { HeaderActionsProvider } from './core/provider/HeaderActionProvider/HeaderAction.js';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import { PWAReloadPrompt } from './components/ui/PWAReloadPrompt/index.js';
// import SplashScreen from './components/ui/SplashScreen/index.js';
// import { persistor, store } from './core/store/index.js';

// function App() {
//   const [showSplash, setShowSplash] = useState(true);
//   const [isReady, setIsReady] = useState(false);

//   useEffect(() => {
//     const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
//     const minTime = isStandalone ? 1000 : 1000;
//     const initializeApp = async () => {
//       await new Promise(resolve => setTimeout(resolve, minTime));
//       setIsReady(true);
//     };
//     initializeApp();
//   }, []);

//   const handleSplashFinish = () => setShowSplash(false);

//   // if (showSplash || !isReady) {
//   //   return <SplashScreen onFinish={handleSplashFinish} />;
//   // }

//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <QueryProvider>
//           <AuthProvider>
//             <HeaderActionsProvider>
//               <BrowserRouter basename="/app">
//                 <ToastProvider />
//                 <PWAReloadPrompt /> {/* ← اینجا اضافه شد */}
//                 <ProtectedRoute>
//                   <Routes>{getRoutes(routes)}</Routes>
//                 </ProtectedRoute>
//               </BrowserRouter>
//             </HeaderActionsProvider>
//           </AuthProvider>
//         </QueryProvider>
//       </PersistGate>
//     </Provider>
//   );
// }

// export default App;

// import { motion, AnimatePresence } from 'framer-motion';




// import './App.css';
// import { BrowserRouter, Routes } from "react-router-dom";
// import { useState, useEffect } from 'react';
// import routes from './Routes/index.js';
// import { getRoutes } from './lib/getRoutes.js';
// import QueryProvider from './core/provider/ReactQuery/index.js';
// import ToastProvider from './core/provider/ToastProvider/index.js';
// import { AuthProvider } from './core/provider/Auth/index.js';
// import ProtectedRoute from './core/provider/ProtectedRoute/index.js';
// import { HeaderActionsProvider } from './core/provider/HeaderActionProvider/HeaderAction.js';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import { persistor, store } from './core/store/index.js';

// interface SplashScreenProps {
//   onFinish: () => void;
//   minDisplayTime?: number;
// }

// function SplashScreen({ onFinish, minDisplayTime = 2500 }: SplashScreenProps) {
//   const [isVisible, setIsVisible] = useState(true);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setIsVisible(false);
//       setTimeout(onFinish, 600);
//     }, minDisplayTime);

//     return () => clearTimeout(timer);
//   }, [minDisplayTime, onFinish]);

//   return (
//     <AnimatePresence>
//       {isVisible && (
//         <motion.div
//           initial={{ opacity: 1 }}
//           exit={{ opacity: 0 }}
//           transition={{ duration: 0.6 }}
//           className="fixed inset-0 z-[9999] flex flex-col items-center justify-between overflow-hidden"
//           style={{
//             background: 'linear-gradient(180deg, #050B1A 0%, #0A1428 40%, #0D1B33 70%, #050B1A 100%)',
//           }}
//         >
//           {/* ستاره‌های پس‌زمینه */}
//           <div className="absolute inset-0 overflow-hidden">
//             {[...Array(50)].map((_, i) => (
//               <motion.div
//                 key={i}
//                 className="absolute w-0.5 h-0.5 bg-white rounded-full"
//                 style={{
//                   left: `${Math.random() * 100}%`,
//                   top: `${Math.random() * 100}%`,
//                 }}
//                 animate={{
//                   opacity: [0.1, 0.8, 0.1],
//                   scale: [1, 1.5, 1],
//                 }}
//                 transition={{
//                   duration: Math.random() * 3 + 2,
//                   repeat: Infinity,
//                   delay: Math.random() * 2,
//                   ease: 'easeInOut',
//                 }}
//               />
//             ))}
//           </div>

//           {/* خطوط آبی نورانی (مدارها) */}
//           <svg
//             className="absolute inset-0 w-full h-full pointer-events-none"
//             viewBox="0 0 400 800"
//             preserveAspectRatio="xMidYMid slice"
//           >
//             <defs>
//               <linearGradient id="blueGlow" x1="0%" y1="0%" x2="100%" y2="100%">
//                 <stop offset="0%" stopColor="#1E90FF" stopOpacity="0" />
//                 <stop offset="50%" stopColor="#1E90FF" stopOpacity="0.8" />
//                 <stop offset="100%" stopColor="#00D4FF" stopOpacity="0" />
//               </linearGradient>
//               <filter id="glow">
//                 <feGaussianBlur stdDeviation="3" result="coloredBlur" />
//                 <feMerge>
//                   <feMergeNode in="coloredBlur" />
//                   <feMergeNode in="SourceGraphic" />
//                 </feMerge>
//               </filter>
//             </defs>

//             {/* قوس‌های آبی */}
//             <motion.path
//               d="M 50 150 Q 200 80 350 200"
//               stroke="url(#blueGlow)"
//               strokeWidth="1.5"
//               fill="none"
//               filter="url(#glow)"
//               initial={{ pathLength: 0, opacity: 0 }}
//               animate={{ pathLength: 1, opacity: 1 }}
//               transition={{ duration: 2, delay: 0.3, ease: 'easeInOut' }}
//             />
//             <motion.path
//               d="M 20 400 Q 200 300 380 450"
//               stroke="url(#blueGlow)"
//               strokeWidth="1"
//               fill="none"
//               filter="url(#glow)"
//               initial={{ pathLength: 0, opacity: 0 }}
//               animate={{ pathLength: 1, opacity: 0.6 }}
//               transition={{ duration: 2.5, delay: 0.5, ease: 'easeInOut' }}
//             />
//             <motion.path
//               d="M 80 600 Q 200 550 320 650"
//               stroke="url(#blueGlow)"
//               strokeWidth="1"
//               fill="none"
//               filter="url(#glow)"
//               initial={{ pathLength: 0, opacity: 0 }}
//               animate={{ pathLength: 1, opacity: 0.4 }}
//               transition={{ duration: 2, delay: 0.7, ease: 'easeInOut' }}
//             />

//             {/* ستاره‌های نورانی روی مدارها */}
//             <motion.circle
//               cx="50"
//               cy="150"
//               r="2"
//               fill="#00D4FF"
//               filter="url(#glow)"
//               animate={{ opacity: [0.3, 1, 0.3], r: [1.5, 2.5, 1.5] }}
//               transition={{ duration: 2, repeat: Infinity }}
//             />
//             <motion.circle
//               cx="350"
//               cy="200"
//               r="2"
//               fill="#00D4FF"
//               filter="url(#glow)"
//               animate={{ opacity: [0.3, 1, 0.3], r: [1.5, 2.5, 1.5] }}
//               transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
//             />
//             <motion.circle
//               cx="380"
//               cy="450"
//               r="2"
//               fill="#1E90FF"
//               filter="url(#glow)"
//               animate={{ opacity: [0.3, 1, 0.3], r: [1.5, 2.5, 1.5] }}
//               transition={{ duration: 2, repeat: Infinity, delay: 1 }}
//             />
//           </svg>

//           {/* محتوای وسط - لوگو و متن */}
//           <div className="flex-1 flex flex-col items-center justify-center relative z-10 -mt-16">
//             {/* لوگو */}
//             <motion.div
//               initial={{ scale: 0.6, opacity: 0 }}
//               animate={{ scale: 1, opacity: 1 }}
//               transition={{
//                 type: 'spring',
//                 stiffness: 200,
//                 damping: 20,
//                 delay: 0.3,
//               }}
//               className="relative"
//             >
//               {/* هاله نورانی پشت لوگو */}
//               <motion.div
//                 className="absolute inset-0 rounded-full"
//                 animate={{
//                   boxShadow: [
//                     '0 0 40px 10px rgba(30, 144, 255, 0.3)',
//                     '0 0 60px 20px rgba(30, 144, 255, 0.5)',
//                     '0 0 40px 10px rgba(30, 144, 255, 0.3)',
//                   ],
//                 }}
//                 transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
//               />

//               {/* لوگوی S - با تصویر */}
//               <div className="relative w-32 h-32 flex items-center justify-center">
//                 <img
//                   src="/app/assets/images/logo.webp"
//                   alt="StreetCard"
//                   className="w-full h-full object-contain drop-shadow-2xl"
//                   style={{ filter: 'brightness(1.2) contrast(1.1)' }}
//                 />
//               </div>
//             </motion.div>

//             {/* نام برند */}
//             <motion.h1
//               initial={{ y: 20, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 0.8, duration: 0.6 }}
//               className="mt-8 text-4xl font-bold text-white tracking-wider"
//               style={{
//                 textShadow: '0 0 20px rgba(30, 144, 255, 0.8), 0 0 40px rgba(30, 144, 255, 0.4)',
//                 fontFamily: 'system-ui, -apple-system, sans-serif',
//               }}
//             >
//               StreetCard
//             </motion.h1>

//             {/* شعار */}
//             <motion.p
//               initial={{ y: 10, opacity: 0 }}
//               animate={{ y: 0, opacity: 1 }}
//               transition={{ delay: 1, duration: 0.6 }}
//               className="mt-2 text-blue-200/70 text-sm"
//             >
//               مدیریت هوشمند پرداخت ها
//             </motion.p>

//             {/* خط جداکننده نورانی */}
//             <motion.div
//               initial={{ scaleX: 0, opacity: 0 }}
//               animate={{ scaleX: 1, opacity: 1 }}
//               transition={{ delay: 1.2, duration: 0.8 }}
//               className="mt-6 w-24 h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent"
//             />
//           </div>

//           {/* شهر دیجیتال پایین */}
//           <div className="absolute bottom-0 left-0 right-0 h-48 pointer-events-none">
//             {/* هاله نورانی افق */}
//             <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-32"
//               style={{
//                 background: 'radial-gradient(ellipse at center bottom, rgba(30, 144, 255, 0.4) 0%, transparent 70%)',
//               }}
//             />

//             {/* خط افق */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ delay: 1.5, duration: 1 }}
//               className="absolute bottom-8 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-400/60 to-transparent"
//             />

//             {/* ساختمان‌ها */}
//             <svg
//               className="absolute bottom-0 left-0 right-0 w-full h-40"
//               viewBox="0 0 400 160"
//               preserveAspectRatio="xMidYMax meet"
//             >
//               <defs>
//                 <linearGradient id="buildingGrad" x1="0%" y1="0%" x2="0%" y2="100%">
//                   <stop offset="0%" stopColor="#1E90FF" stopOpacity="0.6" />
//                   <stop offset="100%" stopColor="#1E90FF" stopOpacity="0.1" />
//                 </linearGradient>
//                 <filter id="buildingGlow">
//                   <feGaussianBlur stdDeviation="1.5" result="blur" />
//                   <feMerge>
//                     <feMergeNode in="blur" />
//                     <feMergeNode in="SourceGraphic" />
//                   </feMerge>
//                 </filter>
//               </defs>

//               <motion.g
//                 initial={{ y: 40, opacity: 0 }}
//                 animate={{ y: 0, opacity: 1 }}
//                 transition={{ delay: 1.3, duration: 1.2, ease: 'easeOut' }}
//                 filter="url(#buildingGlow)"
//                 fill="url(#buildingGrad)"
//                 stroke="#1E90FF"
//                 strokeWidth="0.8"
//                 strokeOpacity="0.8"
//               >
//                 {/* ساختمان‌های سمت چپ */}
//                 <rect x="20" y="80" width="18" height="60" rx="1" />
//                 <rect x="45" y="60" width="22" height="80" rx="1" />
//                 <rect x="75" y="90" width="16" height="50" rx="1" />
//                 <rect x="95" y="70" width="20" height="70" rx="1" />
//                 <rect x="120" y="95" width="15" height="45" rx="1" />
//                 <rect x="140" y="75" width="24" height="65" rx="1" />
//                 <rect x="170" y="50" width="20" height="90" rx="1" />

//                 {/* برج مرکزی */}
//                 <rect x="195" y="30" width="30" height="110" rx="2" />
//                 <line x1="210" y1="30" x2="210" y2="15" stroke="#1E90FF" strokeWidth="1.5" />
//                 <circle cx="210" cy="12" r="2" fill="#00D4FF" />

//                 {/* ساختمان‌های سمت راست */}
//                 <rect x="230" y="55" width="22" height="85" rx="1" />
//                 <rect x="258" y="75" width="18" height="65" rx="1" />
//                 <rect x="280" y="65" width="24" height="75" rx="1" />
//                 <rect x="310" y="85" width="16" height="55" rx="1" />
//                 <rect x="332" y="70" width="20" height="70" rx="1" />
//                 <rect x="358" y="90" width="18" height="50" rx="1" />
//                 <rect x="382" y="80" width="15" height="60" rx="1" />

//                 {/* پنجره‌های نورانی */}
//                 {[...Array(20)].map((_, i) => (
//                   <motion.rect
//                     key={i}
//                     x={Math.random() * 380 + 10}
//                     y={Math.random() * 80 + 50}
//                     width="1.5"
//                     height="2"
//                     fill="#00D4FF"
//                     opacity="0.8"
//                     animate={{ opacity: [0.3, 1, 0.3] }}
//                     transition={{
//                       duration: Math.random() * 2 + 1,
//                       repeat: Infinity,
//                       delay: Math.random() * 2,
//                     }}
//                   />
//                 ))}
//               </motion.g>
//             </svg>
//           </div>

//           {/* خط پایین (زمین) */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 1.8, duration: 1 }}
//             className="absolute bottom-6 left-0 right-0 flex justify-center"
//           >
//             <div className="flex items-center gap-2">
//               <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
//               <p className="text-blue-200/60 text-xs tracking-widest">۲.۰.۰</p>
//               <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
//             </div>
//           </motion.div>

//           {/* لودینگ پایین */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.5 }}
//             className="absolute bottom-32 flex gap-1.5"
//           >
//             {[0, 1, 2, 3].map((i) => (
//               <motion.div
//                 key={i}
//                 animate={{
//                   scale: [1, 1.5, 1],
//                   opacity: [0.3, 1, 0.3],
//                 }}
//                 transition={{
//                   duration: 1.2,
//                   repeat: Infinity,
//                   delay: i * 0.15,
//                   ease: 'easeInOut',
//                 }}
//                 className="w-1.5 h-1.5 bg-blue-400 rounded-full"
//                 style={{
//                   boxShadow: '0 0 8px rgba(30, 144, 255, 0.8)',
//                 }}
//               />
//             ))}
//           </motion.div>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// }
// function App() {
//   const [showSplash, setShowSplash] = useState(true);
//   const [isReady, setIsReady] = useState(false);

//   useEffect(() => {
//     const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
//     const minTime = isStandalone ? 1500 : 2500;
//     const initializeApp = async () => {
//       await new Promise(resolve => setTimeout(resolve, minTime));
//       setIsReady(true);
//     };

//     initializeApp();
//   }, []);

//   const handleSplashFinish = () => {
//     setShowSplash(false);
//   };

//   if (showSplash || !isReady) {
//     return <SplashScreen onFinish={handleSplashFinish} minDisplayTime={2500} />;
//   }

//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <QueryProvider>
//           <AuthProvider>
//             <HeaderActionsProvider>
//               <BrowserRouter basename="/app">
//                 <ToastProvider />
//                 <ProtectedRoute>
//                   <Routes>
//                     {getRoutes(routes)}
//                   </Routes>
//                 </ProtectedRoute>
//               </BrowserRouter>
//             </HeaderActionsProvider>
//           </AuthProvider>
//         </QueryProvider>
//       </PersistGate>
//     </Provider>
//   );
// }

// export default App;